/** Dimensões do shell Sebrae — layout estático (único modo em produção). */
export const LAYOUT_TOPBAR_HEIGHT_PX = 70;
export const LAYOUT_SIDEBAR_WIDTH_PX = 288;
export const LAYOUT_DESKTOP_MIN_WIDTH_PX = 897;
